// src/TicketDetails.js
import React from 'react';

const TicketDetails = ({ ticket, onClose }) => {
  if (!ticket) return null;

  return (
    <div className="ticket-details">
      <h2>Ticket Details</h2>
      <button onClick={onClose}>Close</button>
      <div>
        <p><strong>Ticket ID#:</strong> {ticket.ticketId}</p>
        <p><strong>Short Description:</strong> {ticket.shortDescription}</p>
        <p><strong>Assignment Group:</strong> {ticket.assignmentGroup}</p>
        <p><strong>Received On:</strong> {ticket.receivedOn}</p>
        <p><strong>Assigned To:</strong> {ticket.assignedTo}</p>
        <p><strong>Status:</strong> {ticket.status}</p>
        <p><strong>Item:</strong> {ticket.item}</p>
        <p><strong>Priority:</strong> {ticket.priority}</p>
        <p><strong>Action:</strong> {ticket.action}</p>
      </div>
    </div>
  );
};

export default TicketDetails;
